import NoteInfoFold from './NoteInfoFold.vue';
NoteInfoFold.install = (Vue)=>{
    Vue.components(NoteInfoFold.name,NoteInfoFold)
}
export default NoteInfoFold;
